import { SELECT_WORKFLOW_TYPE, UN_SELECT_WORKFLOW_TYPE, RE_ORDER_WORKFLOW_TYPES, ADD_WORKFLOW_TYPE_REQUEST, ADD_WORKFLOW_TYPE, DELETE_WORKFLOW_TYPE, UPDATE_WORKFLOW_TYPE, UPDATE_WORKFLOW_TYPE_START_PIECE, SET_ISOLATED_WORKFLOW_TYPE_PIECE, SELECT_WORKFLOW_TYPE_CUSTOM_FIELD, UN_SELECT_WORKFLOW_TYPE_CUSTOM_FIELD, ADD_WORKFLOW_TYPE_CUSTOM_FIELD, DELETE_WORKFLOW_TYPE_CUSTOM_FIELD, UPDATE_WORKFLOW_TYPE_CUSTOM_FIELD, UPDATE_WORKFLOW_TYPE_CUSTOM_FIELD_START_PIECE, SET_ISOLATED_WORKFLOW_TYPE_CUSTOM_FIELD_PIECE, SELECT_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION, UN_SELECT_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION, RE_ORDER_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION, ADD_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION, DELETE_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION, UPDATE_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION, INewWorkflowTypeData, IUpdateableWorkflowTypeData, REMOVE_ISOLATED_WORKFLOW_TYPE_PIECE, REMOVE_ISOLATED_WORKFLOW_TYPE_CUSTOM_FIELD_PIECE, REGISTER_WORKFLOW_TYPE_VARIABLE, REGISTER_WORKFLOW_TYPE_CUSTOM_FIELD_VARIABLE, SelectWorkflowTypeAction, UnSelectWorkflowTypeAction, ReOrderWorkflowTypesAction, AddWorkflowTypeRequestAction, AddWorkflowTypeAction, UpdateWorkflowTypeAction, UpdateWorkflowTypeRichTextAction, UpdateWorkflowTypeStartPieceAction, SetIsolatedWorkflowTypePieceAction, RemoveIsolatedWorkflowTypePieceAction, RegisterWorkflowTypeVariableAction, DeleteWorkflowTypeAction, SelectWorkflowTypeCustomFieldAction, UnSelectWorkflowTypeCustomFieldAction, AddWorkflowTypeCustomFieldAction, DeleteWorkflowTypeCustomFieldAction, UpdateWorkflowTypeCustomFieldAction, UpdateWorkflowTypeCustomFieldStartPieceAction, SetIsolatedWorkflowTypeCustomFieldPieceAction, RemoveIsolatedWorkflowTypeCustomFieldPieceAction, RegisterWorkflowTypeCustomFieldVariableAction, SelectWorkflowTypeCustomFieldOptionAction, UnSelectWorkflowTypeCustomFieldOptionAction, ReOrderWorkflowTypeCustomFieldOptionAction, AddWorkflowTypeCustomFieldOptionAction, DeleteWorkflowTypeCustomFieldOptionAction, UpdateWorkflowTypeCustomFieldOptionAction, AddWorkflowToWorkflowTypeAction, RemoveWorkflowFromWorkflowTypeAction, ADD_WORKFLOW_TO_WORKFLOW_TYPE, REMOVE_WORKFLOW_FROM_WORKFLOW_TYPE, AddStatusToWorkflowTypeAction, ADD_STATUS_TO_WORKFLOW_TYPE, RemoveStatusFromWorkflowTypeAction, REMOVE_STATUS_FROM_WORKFLOW_TYPE, IWorkflowType, InstantiateWorkflowTypeAction, INSTANTIATE_WORKFLOW_TYPE, InstantiateWorkflowTypeCustomFieldAction, INSTANTIATE_WORKFLOW_TYPE_CUSTOM_FIELD, InstantiateWorkflowTypeCustomFieldOptionAction, INSTANTIATE_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION, UPDATE_WORKFLOW_TYPE_RICH_TEXT, SET_WORKFLOW_TYPE_SEARCH_STRING, SetWorkflowTypeSearchStringAction, REMOVE_BETA_ISOLATED_WORKFLOW_TYPE_PIECE, SET_BETA_ISOLATED_WORKFLOW_TYPE_PIECE, UPDATE_WORKFLOW_TYPE_BETA_START_PIECE, RemoveBetaIsolatedWorkflowTypePieceAction, SetBetaIsolatedWorkflowTypePieceAction, UpdateWorkflowTypeBetaStartPieceAction, PublishFlowchartToLiveAction, PUBLISH_FLOWCHART_TO_LIVE } from './types';
import { INewFieldChoiceData, IUpdateableFieldChoiceData, FieldChoice, INewWorkflowTypeCustomFieldData, IUpdateableWorkflowTypeCustomFieldData, WorkflowTypeCustomField } from '../../custom-fields/types';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { PiecePositionState } from '../../../helpers/common-types';

export function selectWorkflowType(id: string): SelectWorkflowTypeAction {
    return {
        type: SELECT_WORKFLOW_TYPE,
        id,
    }
}

export function unSelectWorkflowType(): UnSelectWorkflowTypeAction {
    return {
        type: UN_SELECT_WORKFLOW_TYPE,
    }
}

export function reOrderWorkflowTypes(sourceIndex: number, destinationIndex: number): ReOrderWorkflowTypesAction {
    return {
        type: RE_ORDER_WORKFLOW_TYPES,
        sourceIndex,
        destinationIndex,
    }
}

export function addWorkflowTypeRequest(payload: INewWorkflowTypeData): AddWorkflowTypeRequestAction {
    return {
        type: ADD_WORKFLOW_TYPE_REQUEST,
        payload,
    }
}

export function addWorkflowType(payload: INewWorkflowTypeData): AddWorkflowTypeAction {
    const now = moment.utc().format();

    return {
        type: ADD_WORKFLOW_TYPE,
        payload: {
            id: uuidv4(),
            ...payload,
            createdTime: now,
            lastUpdatedTime: now,
            workflows: [],
            statuses: [],
            pieces: [],
            variables: [],
            customFields: [],
            isolatedPieces: [],
            betaIsolatedPieces: [],
            previousVersions: [],
        },
        currentTime: now,
    }
}

export function instantiateWorkflowType(payload: IWorkflowType): InstantiateWorkflowTypeAction {
    const now = moment.utc().format();
    return {
        type: INSTANTIATE_WORKFLOW_TYPE,
        payload,
        currentTime: now,
    }
}

export function updateWorkflowType(payload: IUpdateableWorkflowTypeData): UpdateWorkflowTypeAction {
    return {
        type: UPDATE_WORKFLOW_TYPE,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function updateWorkflowTypeRichText(richText: string, workflowTypeId: string): UpdateWorkflowTypeRichTextAction {
    return {
        type: UPDATE_WORKFLOW_TYPE_RICH_TEXT,
        richText,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}

export function setWorkflowTypeSearchString(searchString: string): SetWorkflowTypeSearchStringAction {
    return {
        type: SET_WORKFLOW_TYPE_SEARCH_STRING,
        searchString,
    };
}

export function updateWorkflowTypeStartPiece(payload: PiecePositionState, workflowTypeId: string): UpdateWorkflowTypeStartPieceAction {
    return {
        type: UPDATE_WORKFLOW_TYPE_START_PIECE,
        payload,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}

export function setIsolatedWorkflowTypePiece(payload: PiecePositionState, workflowTypeId: string): SetIsolatedWorkflowTypePieceAction {
    return {
        type: SET_ISOLATED_WORKFLOW_TYPE_PIECE,
        payload,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}

export function removeIsolatedWorkflowTypePiece(pieceId: string, workflowTypeId: string): RemoveIsolatedWorkflowTypePieceAction {
    return {
        type: REMOVE_ISOLATED_WORKFLOW_TYPE_PIECE,
        pieceId,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}

export function registerWorkflowTypeVariable(variableId: string, workflowTypeId: string): RegisterWorkflowTypeVariableAction {
    return {
        type: REGISTER_WORKFLOW_TYPE_VARIABLE,
        variableId,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}



export function updateWorkflowTypeBetaStartPiece(payload: PiecePositionState, workflowTypeId: string): UpdateWorkflowTypeBetaStartPieceAction {
    return {
        type: UPDATE_WORKFLOW_TYPE_BETA_START_PIECE,
        payload,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}

export function setBetaIsolatedWorkflowTypePiece(payload: PiecePositionState, workflowTypeId: string): SetBetaIsolatedWorkflowTypePieceAction {
    return {
        type: SET_BETA_ISOLATED_WORKFLOW_TYPE_PIECE,
        payload,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}

export function removeBetaIsolatedWorkflowTypePiece(pieceId: string, workflowTypeId: string): RemoveBetaIsolatedWorkflowTypePieceAction {
    return {
        type: REMOVE_BETA_ISOLATED_WORKFLOW_TYPE_PIECE,
        pieceId,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}


export function publishFlowchartToLive(workflowTypeId: string): PublishFlowchartToLiveAction {
    return {
        type: PUBLISH_FLOWCHART_TO_LIVE,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}


export function deleteWorkflowType(id: string): DeleteWorkflowTypeAction {
    return {
        type: DELETE_WORKFLOW_TYPE,
        id,
        currentTime: moment.utc().format(),
    }
}

export function addWorkflowToWorkflowType(workflowId: string, workflowTypeId: string): AddWorkflowToWorkflowTypeAction {
    return {
        type: ADD_WORKFLOW_TO_WORKFLOW_TYPE,
        workflowTypeId,
        workflowId,
    }
}

export function removeWorkflowFromWorkflowType(workflowId: string, workflowTypeId: string): RemoveWorkflowFromWorkflowTypeAction {
    return {
        type: REMOVE_WORKFLOW_FROM_WORKFLOW_TYPE,
        workflowTypeId,
        workflowId,
    }
}

export function addStatusToWorkflowType(statusId: string, workflowTypeId: string): AddStatusToWorkflowTypeAction {
    return {
        type: ADD_STATUS_TO_WORKFLOW_TYPE,
        workflowTypeId,
        statusId,
    }
}

export function removeStatusFromWorkflowType(statusId: string, workflowTypeId: string): RemoveStatusFromWorkflowTypeAction {
    return {
        type: REMOVE_STATUS_FROM_WORKFLOW_TYPE,
        workflowTypeId,
        statusId,
    }
}


export function selectWorkflowTypeCustomField(id: string): SelectWorkflowTypeCustomFieldAction {
    return {
        type: SELECT_WORKFLOW_TYPE_CUSTOM_FIELD,
        id,
    }
}

export function unSelectWorkflowTypeCustomField(): UnSelectWorkflowTypeCustomFieldAction {
    return {
        type: UN_SELECT_WORKFLOW_TYPE_CUSTOM_FIELD,
    }
}

export function addWorkflowTypeCustomField(payload: INewWorkflowTypeCustomFieldData, workflowTypeId: string): AddWorkflowTypeCustomFieldAction {
    return {
        type: ADD_WORKFLOW_TYPE_CUSTOM_FIELD,
        payload: {
            id: uuidv4(),
            ...payload,
        },
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}

export function instantiateWorkflowTypeCustomField(payload: WorkflowTypeCustomField, workflowTypeId: string): InstantiateWorkflowTypeCustomFieldAction {
    const now = moment.utc().format();

    return {
        type: INSTANTIATE_WORKFLOW_TYPE_CUSTOM_FIELD,
        payload,
        workflowTypeId,
        currentTime: now,
    }
}

export function deleteWorkflowTypeCustomField(id: string, workflowTypeId: string): DeleteWorkflowTypeCustomFieldAction {
    return {
        type: DELETE_WORKFLOW_TYPE_CUSTOM_FIELD,
        id,
        workflowTypeId,
        currentTime: moment.utc().format(),
    }
}

export function updateWorkflowTypeCustomField(payload: IUpdateableWorkflowTypeCustomFieldData): UpdateWorkflowTypeCustomFieldAction {
    return {
        type: UPDATE_WORKFLOW_TYPE_CUSTOM_FIELD,
        payload,
        currentTime: moment.utc().format(),
    }
}

export function updateWorkflowTypeCustomFieldStartPiece(payload: PiecePositionState, customFieldId: string): UpdateWorkflowTypeCustomFieldStartPieceAction {
    return {
        type: UPDATE_WORKFLOW_TYPE_CUSTOM_FIELD_START_PIECE,
        payload,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function setIsolatedWorkflowTypeCustomFieldPiece(payload: PiecePositionState, customFieldId: string): SetIsolatedWorkflowTypeCustomFieldPieceAction {
    return {
        type: SET_ISOLATED_WORKFLOW_TYPE_CUSTOM_FIELD_PIECE,
        payload,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function removeIsolatedWorkflowTypeCustomFieldPiece(pieceId: string, customFieldId: string): RemoveIsolatedWorkflowTypeCustomFieldPieceAction {
    return {
        type: REMOVE_ISOLATED_WORKFLOW_TYPE_CUSTOM_FIELD_PIECE,
        pieceId,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}

export function registerWorkflowTypeCustomFieldVariable(variableId: string, customFieldId: string): RegisterWorkflowTypeCustomFieldVariableAction {
    return {
        type: REGISTER_WORKFLOW_TYPE_CUSTOM_FIELD_VARIABLE,
        variableId,
        customFieldId,
        currentTime: moment.utc().format(),
    }
}


export function selectWorkflowTypeCustomFieldOption(id: string): SelectWorkflowTypeCustomFieldOptionAction {
    return {
        type: SELECT_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION,
        id,
    }
}

export function unSelectWorkflowTypeCustomFieldOption(): UnSelectWorkflowTypeCustomFieldOptionAction {
    return {
        type: UN_SELECT_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION,
    }
}

export function reOrderWorkflowTypeCustomFieldOption(sourceIndex: number, destinationIndex: number, parentId: string): ReOrderWorkflowTypeCustomFieldOptionAction {
    return {
        type: RE_ORDER_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION,
        sourceIndex,
        destinationIndex,
        parentId,
    }
}

export function addWorkflowTypeCustomFieldOption(payload: INewFieldChoiceData, parentId: string): AddWorkflowTypeCustomFieldOptionAction {
    return {
        type: ADD_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION,
        payload: {
            id: uuidv4(),
            ...payload,
        },
        parentId,
        currentTime: moment.utc().format(),
    }
}

export function instantiateWorkflowTypeCustomFieldOption(payload: FieldChoice, parentId: string): InstantiateWorkflowTypeCustomFieldOptionAction {
    return {
        type: INSTANTIATE_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION,
        payload,
        parentId,
        currentTime: moment.utc().format(),
    }
}

export function deleteWorkflowTypeCustomFieldOption(id: string, parentId: string): DeleteWorkflowTypeCustomFieldOptionAction {
    return {
        type: DELETE_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION,
        id,
        parentId,
        currentTime: moment.utc().format(),
    }
}

export function updateWorkflowTypeCustomFieldOption(payload: IUpdateableFieldChoiceData): UpdateWorkflowTypeCustomFieldOptionAction {
    return {
        type: UPDATE_WORKFLOW_TYPE_CUSTOM_FIELD_OPTION,
        payload,
        currentTime: moment.utc().format(),
    }
}
